import React, { Component } from "react";
import L from "leaflet";
import { Circle } from "react-leaflet";
import { v4 as uuidv4 } from "uuid";
import WinterMaintenceRouteUnitMapPoup from "./WinterMaintenceRouteUnitMapPoup";

class WinterMaintenceRoutesPoupupCircle extends Component {
  render() {
    const { dataPoupup } = this.props;

    if (dataPoupup === null) return null;

    const svgRender = L.svg({
      tolerance: 5,
      padding: 1,
    });

    return (
      <div key={uuidv4()}>
        {Object.values(dataPoupup).map((data) => {
          return data.points.map((point) => {
            return (
              <Circle
                key={uuidv4()}
                center={[parseFloat(point["COOY"]), parseFloat(point["COOX"])]}
                radius={0.5}
                color={"red"}
                fillColor={"red"}
                opacity={1}
                fillOpacity={1}
                weight={10}
                renderer={svgRender}
                eventHandlers={{
                  click: (e) => {
                    /* e.stopPropagation(); */
                    console.log(data.unit, e.target.options);
                  },
                }}
              >
                <WinterMaintenceRouteUnitMapPoup unit={data.unit} point={point} />
              </Circle>
            );
          });
        })}
      </div>
    );
  }
}

export default React.memo(WinterMaintenceRoutesPoupupCircle);
